<template>
  <div class="my-2" :class="isMobile ? 'w-full' : ''">
    <button
      class="mobile-hidden go w-full border-0 rounded"
      type="submit"
      :disabled="disabled"
      :style="{ backgroundColor: color }"
      @click="(e) => this.$emit('click', e)"
    >
      {{ onEditMode() ? "Atualizar" : "Continuar" }}
    </button>
    <button
      class="go w-full sm:hidden border-0 rounded"
      type="submit"
      :disabled="disabled"
      :style="{ backgroundColor: color }"
      @click="(e) => this.$emit('click', e)"
    >
      {{ onEditMode() ? "Atualizar" : "Continuar" }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "forward-button",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    showBackward() {
      return this.isSecondStep ? false : true;
    },
  },
  computed: {
    ...mapGetters("step", ["isLastStep"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },

    isMobile() {
      return window.innerWidth < 1024;
    },
  },
};
</script>

<style lang="scss" scoped>
.go {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.85rem 2.5rem;
  color: white;

  &:hover {
    cursor: pointer;
  }
}
</style>
